import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    dataset: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    dataset () {
      this.renderChart(this.dataset, this.options)
    },
  },
  mounted () {
    this.renderChart(this.dataset, this.options)
  },
}
